import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { mergeExistingOrder } from '../../stateManagement/engine/actions/OrderHistoryActions';
import OrderHistory from './OrderHistory';

function mapStateToProps(state, ownProps) {
  return {
    locale: state.session.organization.locale,
    currency: state.session.organization.currency,
    unavailableOrderItems: state.order.unavailableOrderItems,
    displayableOrders: state.order.orderHistoryDisplayable,
    orders: state.order.orderHistory,
    orderAddress: state.order.address,
    restaurantAddress: state.session.organization.address.latLng,
    ownProps,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const boundActionCreators = bindActionCreators(
    {
      onAddToOrderClick: mergeExistingOrder,
    },
    dispatch,
  );

  return {
    ...boundActionCreators,
    ...ownProps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderHistory);
